import React, { Component } from "react";
import * as R from "ramda";
import {
  transformResponseYearsToDateToTable,
  configYearToDate,
  yearOptions,
} from "../config";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";
import { mapToObjectDDL, removeNullFields } from "../../../../common/mapper";

class YearToDateSalesReport extends Component {
  constructor(props) {
    super(props);
    let currentDate = new Date();
    this.state = {
      year: yearOptions.find(
        (item) => item.value === currentDate.getFullYear(),
      ),
      teamLead: null,
      tableConfig: configYearToDate(),
      dataTable: [],
      dataTL: [],
    };
  }

  componentDidMount = async () => {
    this.fetchDataTL();
    this.fetchData();
  };

  componentDidUpdate = async (prevProps) => {
    if (prevProps.doSearch !== this.props.doSearch && this.props.doSearch) {
      this.setState(
        {
          teamLead: null,
          dataTL: [],
        },
        () => {
          this.fetchData();
          this.fetchDataTL();
        },
      );
    }
  };

  fetchDataTL = async () => {
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterSales,
      setError: this.props.setError,
      menuName:
        "Dashboard Level Koordinator- Laporan Statistik Prospek Per Salesman / CS",
      args: { paramFilters: { kodeCabang: this.props.search?.value, userNameLead: this.props.usernameLogin} },
    });
    this.props.onSuccessSearch();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prevValue) => ({
        ...prevValue,
        dataTL: res.data.data,
      }));
    }
  };

  fetchData = async () => {
    this.props.triggerLoading();
    const request = removeNullFields({
      kodeCabang: [this.props.search?.value],
      year: this.state.year?.value,
      employeeIdTeamLeader: this.state.teamLead?.value,
      employeeIdSales: null,
    });

    const res = await fetchDataAsync({
      asyncFn:
        Api.create("NAGAMAS_REPORT_DTO")
          .getLaporanPenjualanYTDMetodePembayaranDanLeasing,
      setError: this.props.setError,
      menuName:
        "Dashboard Level Kepala Cabang Keatas - Laporan Jualan Year To Date",
      args: request,
    });

    this.props.triggerLoading();
    this.props.onSuccessSearch();

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: transformResponseYearsToDateToTable(res.data.data),
      }));
    }
  };

  handleChangeSearchValue = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  handleSearch = () => {
    this.setState(
      (prev) => ({
        ...prev,
        tableConfig: configYearToDate(prev.year?.value),
      }),
      () => this.fetchData(),
    );
  };

  render() {
    return (
      <React.Fragment>
        <FlexView style={{ gap: "20px", alignItems: "center" }}>
          <SimpleDDL
            id="select_options_year"
            box="search"
            name="year"
            isClearable
            containerclassname="width width-250px"
            placeholder="Tahun"
            menuPosition="fixed"
            options={yearOptions}
            value={this.state.year}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleDDL
            id="select_options_team_lead"
            box="search"
            name="teamLead"
            isClearable
            containerclassname="width width-250px"
            placeholder="Select TL"
            menuPosition="fixed"
            options={this.state.dataTL.map((item) =>
              mapToObjectDDL(item.salesLeadName, item.employeeId),
            )}
            value={this.state.teamLead}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleButton
            styles={{ marginBottom: "15px" }}
            onClick={() => this.handleSearch()}
          >
            Cari
          </SimpleButton>
        </FlexView>
        <SimpleDataTable
          data={this.state.dataTable}
          columns={this.state.tableConfig}
        />
      </React.Fragment>
    );
  }
}

export default YearToDateSalesReport;
